import { IApplicationState } from '../../types/redux';

export function selectSeoCrossLinks(state: IApplicationState) {
  return state.crossLinks;
}
